import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

/* Spiegelt die tatsächliche Speicherung der Anwendung wider — es gibt
   KEINE Tracking-/Analyse-Cookies. Falls später Tracker ergänzt werden,
   muss diese Seite UND ein Einwilligungs-Banner nachgezogen werden. */

export default function CookiesPage() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: "'Manrope', sans-serif" }}>
      <div className="max-w-3xl mx-auto px-6 py-16">
        <button onClick={() => navigate(-1)} data-testid="cookies-back-btn" className="flex items-center gap-2 text-sm text-[#4B5563] hover:text-[#0A0A0A] mb-8">
          <ArrowLeft size={16} /> Zurück
        </button>
        <h1 className="text-3xl font-bold text-[#0A0A0A] mb-8">Cookie-Hinweise</h1>
        <div className="prose prose-gray max-w-none space-y-6 text-[#4B5563] leading-relaxed">

          <h2 className="text-xl font-bold text-[#0A0A0A]">Keine Tracking-Cookies</h2>
          <p>
            Diese Website verwendet <strong>keine Tracking-, Analyse- oder Marketing-Cookies</strong> und
            bindet keine Analyse-Dienste von Drittanbietern ein. Es wird ausschließlich technisch
            notwendige Speicherung eingesetzt, die für den Betrieb der Anwendung erforderlich ist
            (§ 25 Abs. 2 TDDDG, vormals TTDSG) — dafür ist keine Einwilligung erforderlich.
          </p>

          <h2 className="text-xl font-bold text-[#0A0A0A]">Eingesetzte Speicherung im Detail</h2>
          <div className="overflow-x-auto">
            <table className="w-full text-sm border border-gray-200">
              <thead>
                <tr className="bg-gray-50">
                  <th className="text-left px-3 py-2 border-b border-gray-200 font-semibold text-[#0A0A0A]">Name</th>
                  <th className="text-left px-3 py-2 border-b border-gray-200 font-semibold text-[#0A0A0A]">Art</th>
                  <th className="text-left px-3 py-2 border-b border-gray-200 font-semibold text-[#0A0A0A]">Zweck</th>
                  <th className="text-left px-3 py-2 border-b border-gray-200 font-semibold text-[#0A0A0A]">Dauer</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b border-gray-100">
                  <td className="px-3 py-2 font-mono text-xs">auth_token</td>
                  <td className="px-3 py-2">Cookie (httpOnly, secure)</td>
                  <td className="px-3 py-2">Login-Sitzung für Mitarbeiter (nur nach Anmeldung gesetzt)</td>
                  <td className="px-3 py-2">7 Tage</td>
                </tr>
                <tr className="border-b border-gray-100">
                  <td className="px-3 py-2 font-mono text-xs">theme</td>
                  <td className="px-3 py-2">localStorage</td>
                  <td className="px-3 py-2">Gespeicherte Design-Einstellung (Hell-/Dunkelmodus)</td>
                  <td className="px-3 py-2">bis zur Löschung durch Sie</td>
                </tr>
                <tr>
                  <td className="px-3 py-2 font-mono text-xs">selectedPlan u. a.</td>
                  <td className="px-3 py-2">sessionStorage</td>
                  <td className="px-3 py-2">Zwischenspeicher im internen Verkaufsablauf (nur Mitarbeiterbereich)</td>
                  <td className="px-3 py-2">bis zum Schließen des Tabs</td>
                </tr>
              </tbody>
            </table>
          </div>

          <h2 className="text-xl font-bold text-[#0A0A0A]">Verwaltung</h2>
          <p>
            Sie können Cookies und lokale Speicherung jederzeit über die Einstellungen Ihres Browsers
            einsehen und löschen. Da ausschließlich technisch notwendige Speicherung eingesetzt wird,
            kann das Löschen dazu führen, dass Sie sich neu anmelden müssen bzw. Einstellungen
            zurückgesetzt werden.
          </p>

          <p className="text-sm text-gray-400">Stand: Juli 2026</p>
        </div>
      </div>
    </div>
  );
}
